/**
 * 给接口打一些日志
 */
import { jstLogEvent, logger } from './logger'
import { getConfigCache } from '@/services/admin/securityConfig'
import { wrapResponseData } from '@/utils/wrapRequest'

export const apiLogWapper = (apiFun, log = '', filter = () => true) => {
    return (...args) => {
        if (filter(...args)) {
            jstLogEvent({ element: log })
        }
        return apiFun(...args)
    }
}

let configPromise = null

const loadConfig = () => {
    if (configPromise) {
        return configPromise
    }

    configPromise = wrapResponseData(() =>
        getConfigCache({
            key: 'API_LOG_LIST'
        })
    ).catch(() => null)

    return configPromise
}

export const logApi = async options => {
    try {
        if (!options.url?.startsWith?.('http')) {
            return
        }

        const urlObj = new URL(options.url)

        if (urlObj?.pathname?.includes?.('/open')) {
            return
        }

        const currentPage = logger.getPage()

        const config = await loadConfig()

        if (!config) {
            return
        }

        const configParsed = JSON.parse(config)

        if (Array.isArray(configParsed) && configParsed.includes(urlObj.pathname)) {
            jstLogEvent({ element: urlObj.pathname, ...currentPage })
        }
    } catch (e) {
        console.error(e)
    }
}
